import React, { Component, useState, useEffect, useContext } from "react";
import { alert_error, alert_success } from '../../../AppContext';
import AdSense from 'react-adsense';
import { Link, useLocation } from 'react-router-dom';
import { BrowserRouter as Router, Switch, useNavigate } from 'react-router-dom';
import { Cookies } from '../../../index.js';
import { Helmet } from "react-helmet";
import { ClipLoader, PulseLoader } from 'react-spinners';
import axios from "axios";
import queryString from 'query-string';
import Swal from 'sweetalert2';

function Nhatkyorders({ id_seller_orders }) {
    const navigate = useNavigate();
    const delete_phone = (value) => {
        // setnutorder('đặt tiếp luôn nào')
        Swal.fire({
            title: 'Thông báo',
            text: 'Orders tiếp đươn videos ' + value + ' với phí 500 Coins',
            icon: 'info',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Đồng ý',
            cancelButtonText: 'Từ chối',
        }).then((result) => {
            console.log(result);
            // If user agrees, set agreed to true
            if (result.isConfirmed) {
                console.log('đồng ý');
                // setnutxuly(1);
                // setnutorder('Please wait a moment 😊');
                delete_process(value);
            } else {
            }
        });
    };
    function delete_process(value) {
        navigate('/reactapp/videos_maker/orders?id_orders=' + value );
    };
    function testFunction(response) {
        const info = response.data;
        const status = info.status;
        const message = info.message;

        if (status == 0) {
            alert_error(info.message);
        }
        else if (status == 1) {
            alert_success(info.message);
        }
        if (info.redirect != null && info.redirect != '') {
            setTimeout(function () {
                // Chuyển hướng sang trang web khác
                window.location.href = info.redirect;
            }, 1700);
        }
    };
    return (
        <>
            <button>
                <div onClick={() => delete_phone(id_seller_orders)} className="mx-1 inline-block text-base font-bold px-2 py-1 
              border-2 border-purple-500 mt-2 rounded-pill text-wrap">
                    <div className="text-purple-500 text-xs">Continue</div>
                </div>
            </button>
        </>
    );
};

export default Nhatkyorders;
